module.exports = __webpack_public_path__ + "img/earth-globe.cd7d7889.svg";